module.exports = __webpack_public_path__ + "img/ad1_img.b271dbb8.png";